import * as yup from 'yup'

export const schemaNewPassword = yup.object().shape({
  password: yup.string().required().min(8).strongPassword(),
  passwordConfirm: yup
    .string()
    .required()
    .min(8)
    .equalsSibling('password', 'Senhas não coincidem.'),
})

export default schemaNewPassword
